import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';

export const makeCartStyles = makeStyles(
    (theme: Theme) => ({
        button: {
            fontSize: '1.125rem',
            fontWeight: 600,
            width: '100%',
        },
        icon: {
            alignItems: 'center',
            display: 'flex',
            marginLeft: theme.spacing(1),
        },
        summaryWrapper: {
            position: 'sticky',
            top: theme.spacing(1),

            [theme.breakpoints.down('sm')]: {
                position: 'static',
            },
        },
        orderTypeWrapper: {
            marginTop: 32,

            [theme.breakpoints.down('sm')]: {
                marginTop: 12,
            }
        }
    }),
    { index: 1 },
);
